import "jquery-form";
import ssoAlert from "./sso.alert";
import ssoTool from "./sso.tool";

const ssoAjax = {
    _getErrorMessage(response) {
        return response?.responseJSON?.message || 'something wrong';
    },
    withAuth() {
        this.auth = true;

        return this;
    },
    auth: false,
    refreshToken: request => {
        if (!request || typeof request  != "object") {
            return;
        }

        const newToken = request.getResponseHeader('authorization');

        if (newToken) {
            ssoTool.setCookie('sso_token', newToken);
        }
    },
    getToken() {
        return ssoTool.getCookie('sso_token');
    },
    _getTranslation(message) {
        return (window.language && window.language[message]) ? window.language[message] : message;
    },
    authSubmit(url, doneCallback = null, failCallback = null) {
        let that = this;
        const token = this.getToken();

        this.checkToken();

        $.ajax({
            url: url,
            dataType: 'json',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).always((response, status, request) => {
            this.refreshToken(request);
        }).done((response) => {
            if (doneCallback !== null) {
                doneCallback(response);
            }
        }).fail(response => {
            if (failCallback !== null) {
                failCallback(response);

                return false;
            }

            if (response.status === 401) {
                that.redirectToLogin();

                return false;
            }

            let errorCode = response?.responseJSON?.code;
            let errorMessage = this._getErrorMessage(response);
            let displayMessage = (errorCode && window.language?.[errorCode])
                ? window.language[errorCode]
                : this._getTranslation(errorMessage);

            ssoAlert.error(displayMessage);
        });

        return this;
    },
    setOptions(options) {
        this.options = options;

        return this;
    },
    options: {},
    redirectToLogin() {
        window.location = `?channel=sso&redirect_url=${currentUri}`;
    },
    checkToken() {
        const token = this.getToken();

        if (token === undefined || token === '') {
            this.redirectToLogin();
        }

        return this;
    },
    submit(form, successCallback = null, errorCallback = null) {
        let that = this;
        let options = {
            dataType: 'json',
            beforeSubmit: () => {
                that.btnSetToLoading();
            },
            success: (response, status, request) => {
                this.refreshToken(request)

                if (successCallback !== null) {
                    successCallback(response);

                    return false;
                }

                if (response.status === false) {
                    ssoAlert.error(this._getTranslation(response.message));
                }

                that.btnSetToSubmit();
            },
            error: response => {
                if (errorCallback !== null) {
                    errorCallback(response);

                    return false;
                }

                if (response.status === 401) {
                    that.redirectToLogin();

                    return false;
                }

                that.btnSetToSubmit();

                let errorCode = response?.responseJSON?.code;
                let errorMessage = this._getErrorMessage(response);
                let displayMessage = (errorCode && window.language?.[errorCode])
                    ? window.language[errorCode]
                    : this._getTranslation(errorMessage);

                ssoAlert.error(displayMessage);
            }
        }

        let finalOptions = $.extend(options, this.options)

        if (this.auth === true) {
            this.checkToken();
            const token = this.getToken();

            finalOptions.headers = {
                'Authorization': `Bearer ${token}`
            }
        }

        $(form).ajaxSubmit(finalOptions);

        return this;
    },
    btnSetToLoading() {
        $('#btn_submit').addClass('loading').prop('disabled', true);

        return this;
    },
    btnSetToSubmit() {
        $('#btn_submit').removeClass('loading').prop('disabled', false);

        return this;
    },
};

export default ssoAjax;
